import { ProductRouteType } from './types'
import { guardIsEnum } from '../../../utils/typeUtils'
import { isNonEmptyString } from '../../../utils/stringUtils'
import { parsePathSegments } from '../../../utils/UrlUtils'

interface BuildProductPathParams {
  locale: string
  productType: ProductRouteType
  options?: {
    variant?: string
    itemId?: string
    slug?: string
  }
}

export function buildProductPath({
  locale,
  productType,
  options,
}: BuildProductPathParams): string {
  const { variant, itemId, slug } = options || {}

  let path = `/${locale}/${productType}`

  switch (productType) {
    case ProductRouteType.CANVAS:
      if (variant) {
        path += `/${variant}`
      }
      break

    case ProductRouteType.PHOTOTILES:
      if (slug) {
        path += `/${slug}`
      }
      break

    case ProductRouteType.PHOTOBOOKS:
      if (itemId) {
        path += `/${itemId}`
      }
      break

    case ProductRouteType.ART:
      if (itemId) {
        path += `/${itemId}`
        if (slug) {
          path += `/${slug}`
        }
      }
      break

    default:
      if (variant) {
        path += `/${variant}`
      }
  }

  return path
}

export function getProductTypeFromPathname(
  pathname: string
): ProductRouteType | null {
  if (!isNonEmptyString(pathname)) {
    return null
  }

  const segments = parsePathSegments(pathname)

  // Check if we have at least 2 segments and second segment is a product type
  if (segments.length > 1 && guardIsEnum(segments[1], ProductRouteType)) {
    return segments[1] as ProductRouteType
  }

  return null
}
